import { z } from 'zod';
export const trainingImportCapability = 'training.import-reconciliation.v1';
export const trainingImportManifestVersion = 'training-source-manifest.v1';
export const trainingImportMappingVersion = 'training-normalized-v1';
export const trainingImportEntityTypeSchema = z.enum([
    'course-release-reference',
    'assignment',
    'progress',
    'assessment-attempt',
    'activity-session',
    'professional-certification',
]);
export const trainingImportRunStatusSchema = z.enum([
    'prepared', 'applying', 'reconciled', 'failed', 'rolled-back',
]);
export const trainingImportCountsByEntitySchema = z.strictObject({
    'course-release-reference': z.number().int().nonnegative().safe(),
    assignment: z.number().int().nonnegative().safe(),
    progress: z.number().int().nonnegative().safe(),
    'assessment-attempt': z.number().int().nonnegative().safe(),
    'activity-session': z.number().int().nonnegative().safe(),
    'professional-certification': z.number().int().nonnegative().safe(),
});
const unsignedTotalSchema = z.number().int().nonnegative().safe();
export const trainingImportDomainTotalsSchema = z.strictObject({
    referencedCourseCount: unsignedTotalSchema,
    referencedReleaseCount: unsignedTotalSchema,
    assignmentCount: unsignedTotalSchema,
    completedAssignmentCount: unsignedTotalSchema,
    waivedAssignmentCount: unsignedTotalSchema,
    progressCount: unsignedTotalSchema,
    completedProgressCount: unsignedTotalSchema,
    completionPercentageTotal: unsignedTotalSchema,
    assessmentAttemptCount: unsignedTotalSchema,
    submittedAssessmentCount: unsignedTotalSchema,
    passedAssessmentCount: unsignedTotalSchema,
    assessmentScoreBasisPointsTotal: unsignedTotalSchema,
    activitySessionCount: unsignedTotalSchema,
    closedActivitySessionCount: unsignedTotalSchema,
    activitySecondsTotal: unsignedTotalSchema,
    activityInteractionCount: unsignedTotalSchema,
    activityHeartbeatCount: unsignedTotalSchema,
    certificationCount: unsignedTotalSchema,
    currentCertificationCount: unsignedTotalSchema,
    supersededCertificationCount: unsignedTotalSchema,
    revokedCertificationCount: unsignedTotalSchema,
    certificationEvidenceCount: unsignedTotalSchema,
});
export const trainingImportRunSummarySchema = z.strictObject({
    contractVersion: z.literal(trainingImportCapability),
    tenantId: z.string().uuid(),
    id: z.string().uuid(),
    manifestVersion: z.literal(trainingImportManifestVersion),
    mappingVersion: z.literal(trainingImportMappingVersion),
    sourceSystem: z.literal('crest-crm'),
    sourceRepository: z.literal('jakeflora-cell/crest-crm'),
    sourceCommitSha: z.string().regex(/^[a-f0-9]{40}$/),
    sourceTreeSha: z.string().regex(/^[a-f0-9]{40}$/),
    sourceSchemaSha256: z.string().regex(/^[a-f0-9]{64}$/),
    sourceManifestSha256: z.string().regex(/^[a-f0-9]{64}$/),
    capturedAt: z.string().datetime({ offset: true }),
    writerFenceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    sourceWriterState: z.enum(['authoritative', 'frozen']),
    targetWriterState: z.literal('disabled'),
    noDualWriters: z.literal(true),
    tenantExternalKey: z.string().trim().min(1).max(240),
    runKind: z.enum(['base', 'final-delta']),
    sourceEpoch: z.string().trim().min(1).max(240),
    parentSourceSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    planSha256: z.string().regex(/^[a-f0-9]{64}$/),
    status: trainingImportRunStatusSchema,
    sourceRows: z.number().int().nonnegative(),
    plannedRows: z.number().int().nonnegative(),
    rejectedRows: z.number().int().nonnegative(),
    appliedRows: z.number().int().nonnegative().nullable(),
    skippedRows: z.number().int().nonnegative().nullable(),
    targetSha256: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    countsByEntity: trainingImportCountsByEntitySchema.nullable(),
    domainTotals: trainingImportDomainTotalsSchema.nullable(),
    failureReasonCode: z.string().trim().min(3).max(160).nullable(),
    rollbackReason: z.string().trim().min(10).max(1_000).nullable(),
    startedByMembershipId: z.string().uuid(),
    startedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
    rolledBackAt: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=training-import.contract.js.map